var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
    nav: true,
    'in-popover': _vm.isInPopover,
  }},[_c('div',{class:{
      'nav-arrow':true,
      left:true,
      'in-popover': _vm.isInPopover,
      'disable': _vm.isPrevDisable
    },on:{"click":function () { return _vm.isPrevDisable || _vm.$emit('prevClick'); }}}),_c('div',{class:("nav-title " + (_vm.isInPopover ? 'in-popover' : '')),style:({ whiteSpace: 'nowrap', fontWeight: 600 }),attrs:{"role":"button"},on:{"click":function () { return _vm.$emit('titleClick'); }}},[_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")]),_c('div',{class:("nav-arrow  " + (_vm.isInPopover ? 'in-popover' : '')),on:{"click":function () { return _vm.$emit('nextClick'); }}})])}
var staticRenderFns = []

export { render, staticRenderFns }